import { useMemo } from 'react';

// Shared
import { useData } from '@/common/dataContext';

// Relative imports
import { isFeatureModuleEnabled } from './isFeatureModuleEnabled';

/**
 * Hook to check if a specific feature module is enabled for the current company.
 * @param {import('@/constants/types').FeatureModule} moduleKey - The key of the module from FEATURE_MODULES
 * @returns {boolean} True if the module is enabled, false otherwise.
 */
export const useIsFeatureModuleEnable = (moduleKey) => {
  const { companyPreferences } = useData();

  return useMemo(
    () => isFeatureModuleEnabled(companyPreferences, moduleKey),
    [companyPreferences, moduleKey]
  );
};
